import {
  RECRUITER_DETAIL_SET,
  RECRUITER_DETAIL_SET_SUCCESS,
  RECRUITER_DETAIL_SET_ERROR,
  RECRUITER_DETAIL_GET_COUNTRY,
  RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL,
  RECRUITER_DETAIL_GET_COUNTRY_FAILED,
  RECRUITER_DETAIL_GET_STATE,
  RECRUITER_DETAIL_GET_STATE_SUCCESSFULL,
  RECRUITER_DETAIL_GET_STATE_FAILED,
  RECRUITER_DETAIL_GET_IP_LOCATION,
  RECRUITER_DETAIL_GET_IP_LOCATION_FAILED,
  RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  RECRUITER_PROFILE_ERROR, 
  RECRUITER_PROFILE_SUCCESS, 
  RECRUITER_EDIT_PROFILE, 
  RECRUITER_RESET_PROFILE_FLAG ,
  RECRUITER_GET_PROFILE_DETAIL,
  RECRUITER_GET_PROFILE_DETAIL_SUCCESS,

} from "./actionTypes"

export const detailSet = (user, history) => {
  return {
    type: RECRUITER_DETAIL_SET,
    payload: { user, history },
  }
}

export const detailSetSuccess = message => {
  return {
    type: RECRUITER_DETAIL_SET_SUCCESS,
    payload: message,
  }
}

export const detailSetError = message => {
  return {
    type: RECRUITER_DETAIL_SET_ERROR,
    payload: message,
  }
}
//GET COUNTRY
export const detailGetCountry = (country) => {
  return {
    type: RECRUITER_DETAIL_GET_COUNTRY,
    payload: {country},
  }
}
export const detailSetCountrySuccess = (country) => {
  return {
    type: RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL,
    payload: country,
  }
}
export const detailSetCountryError = (country) => {
  return {
    type: RECRUITER_DETAIL_GET_COUNTRY_FAILED,
    payload: country,
  }
}
//GET STATE FUNCTIONS
export const detailGetState = (states) => {
  return {
    type: RECRUITER_DETAIL_GET_STATE,
    payload: {states},
  }
}
export const detailSetStateSuccess = (states) => {
  return {
    type: RECRUITER_DETAIL_GET_STATE_SUCCESSFULL,
  payload: states,
  }
}
export const detailSetStateError = (states) => {
  return {
    type: RECRUITER_DETAIL_GET_STATE_FAILED,
    payload: states,
  }
}
//GET COUNTRY AND STATE ON IP BASED FUNCTIONS
export const detailGetIpBasedLocation = (iplocation) => {
  return {
    type: RECRUITER_DETAIL_GET_IP_LOCATION,
    payload: {iplocation},
  }
}
export const detailGetIpBasedLocationSuccess = (iplocation) => {
  return {
    type: RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  payload: iplocation,
  }
}
export const detailGetIpBasedLocationError = (iplocation) => {
  return {
    type: RECRUITER_DETAIL_GET_IP_LOCATION_FAILED,
    payload: iplocation,
  }
}

export const editProfile = user => {
  return {
    type: RECRUITER_EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: RECRUITER_PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: RECRUITER_PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RECRUITER_RESET_PROFILE_FLAG,
  }
}

export const getProfileDetail = user => {
  return {
    type: RECRUITER_GET_PROFILE_DETAIL,
    payload: { user },
  }
}
  
export const getProfileDataSucess = user => {
  return {
    type: RECRUITER_GET_PROFILE_DETAIL_SUCCESS,
    payload: { user },
  }

}